import React from 'react'
import { confirmDialog } from 'primereact/confirmdialog'
import './highQuantityConfirm.scss'

/** Quantity above this threshold triggers an extra confirmation when adding or first crossing it while editing. */
export const HIGH_ORDER_QUANTITY_THRESHOLD = 10

/**
 * @param {Object} params
 * @param {number} params.newQuantity
 * @param {number|null|undefined} params.originalLineQuantity — `null`/`undefined`: new line (e.g. add from alternatives). A number: quantity already on the line when the modal was opened.
 */
export function shouldConfirmHighQuantity({ newQuantity, originalLineQuantity }) {
  const q = Number(newQuantity)
  if (!Number.isFinite(q) || q <= HIGH_ORDER_QUANTITY_THRESHOLD) return false
  if (originalLineQuantity === null || originalLineQuantity === undefined) return true
  return Number(originalLineQuantity) <= HIGH_ORDER_QUANTITY_THRESHOLD
}

export function HighQuantityConfirmMessage({ quantity, threshold }) {
  const q = Number(quantity)
  const display = Number.isFinite(q) ? q : '—'

  return (
    <div className='high-qty-confirm-message'>
      <div className='high-qty-confirm-message__symbol' aria-hidden='true'>
        <i className='pi pi-info-circle' />
      </div>
      <div className='high-qty-confirm-message__body'>
        <div className='high-qty-confirm-message__quantity'>
          {display}
          <span className='high-qty-confirm-message__quantity-suffix'>units</span>
        </div>
        <p className='high-qty-confirm-message__lead'>
          That is more than {threshold} on this order line.
        </p>
        <p className='high-qty-confirm-message__hint mb-0'>
          Continue only if this matches what you intend to order.
        </p>
      </div>
    </div>
  )
}

/**
 * @param {Object} params
 * @param {number} params.quantity
 * @param {() => void} params.onAccept
 */
export function openHighQuantityConfirmDialog({ quantity, onAccept }) {
  confirmDialog({
    className: 'high-qty-confirm-dialog',
    header: 'Review quantity',
    message: (
      <HighQuantityConfirmMessage
        quantity={quantity}
        threshold={HIGH_ORDER_QUANTITY_THRESHOLD}
      />
    ),
    acceptLabel: 'Continue',
    rejectLabel: 'Go back',
    acceptIcon: 'pi pi-check',
    rejectIcon: 'pi pi-arrow-left',
    rejectClassName: 'p-button-outlined p-button-secondary',
    style: { width: '100%', maxWidth: '26rem' },
    breakpoints: { '641px': '95vw' },
    dismissableMask: true,
    accept: onAccept,
  })
}
